import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, ArticleStatus } from './index';
import { PaginationProps } from '../types';

export type ArticleType = 'blog' | 'history' | 'psychology';

export type ArticleListData = AnyObject

export type ArticleListResponse = ArticleListData

export type ArticleOrderColumn = 'id' | 'name' | 'createdAt' | 'updatedAt';

export type ArticleListGetParams = PaginationProps<ArticleOrderColumn> & {
  name?: string;
  tag?: string | null;
  status?: ArticleStatus | null;
  updatedAtStart?: string;
  updatedAtEnd?: string;
  // Statis for diff types of articles
  articleType?: ArticleType;
}

export const articleListGet = (payload: ArticleListGetParams): Action<ArticleListGetParams> => ({
  type: actions.articleListTrigger.toString(),
  payload,
});

export const articleListClear = (): Action => ({
  type: actions.articleListClear.toString(),
});

export const articleListErrorClear = (): Action => ({
  type: actions.articleListErrorReset.toString(),
});

export function* articleListRequestSaga({ payload }: Action<ArticleListGetParams>) {
  yield put({
    type: actions.articleListStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.articleListError.toString(),
      payload: {
        message: 'ArticleList: Parameters not passed.',
      },
    });

    return;
  }

  const { roles, ...restParams } = payload;

  const params = new URLSearchParams(Object.entries(restParams).filter((entry) => !!entry[1]));

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/articles?${params.toString()}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<ArticleListData, ArticleListResponse>(
    response,
    actions.articleListSuccess.toString(),
    actions.articleListError.toString(),
    false,
    (articleListData) => articleListData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.articleListTrigger.toString(),
    defaultProcessingSaga(
      articleListRequestSaga,
      {
        error: actions.articleListError.toString(),
        locationCancel: actions.articleListClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.articleListSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.articleListError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.articleListErrorReset.toString(),
    });
  });
}
